<template>
  <div class="panel-in-tab">
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <div style="height: 5px"></div>
        <el-button type="primary" size="mini" @click="edit(null)">新增</el-button>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        stripe
        highlight-current-row
        :height="maxTableHeight"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        v-loading="loading"
      >
        <el-table-column label="得分上线" prop="limitUpper"></el-table-column>
        <el-table-column label="得分下限" prop="limitLower"></el-table-column>
        <el-table-column label="提成系数" prop="factor"></el-table-column>
        <!-- <el-table-column label="更新人" prop="updatedBy"></el-table-column> -->
        <el-table-column label="更新时间" prop="lastUpdateDate"></el-table-column>
        <el-table-column label="操作" width="180px" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="edit(scope.row)">编辑</el-link>
            <el-link type="primary" :underline="false" @click="adjustingRecords(scope.row)">查看调整记录</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <edit-dialog ref="content" :visible.sync="dialogVisible" :tableDataList="editData" @success="onSearch" v-if="dialogVisible"/>
    <adjustment-record-dialog :visible.sync="isShowAdjustmentRecord" :rowData="rowData" @success="onSearch" v-if="isShowAdjustmentRecord"/>
  </div>
</template>

<script>
import axios from "@/utils/axiosInstance";
import editDialog from "./components/edit";
import adjustmentRecordDialog from "./components/adjustmentRecord"
import tableMixin from "@/utils/tableMixin";
export default {
  mixins: [tableMixin],
  components: { editDialog, adjustmentRecordDialog },
  data() {
    return {
      form: {
        storeName: '全部',
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      isShowAdjustmentRecord: false,
      dialogConfig: {},
      rowData: {},
      storeList: [],
      editData: [],
      queryCriteria: [],
      searchFormData: [],
      loading: false,
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.queryCriteria = [];
      this.init();
    },
    async init() {
      this.loading = true;
      this.$q.newProduct.queryCommissionFactors()
        .then((res) => {
          if (res.code == 200) {
            this.tableData.list = res.data;
            this.editData = JSON.parse(JSON.stringify(this.tableData.list))
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = row;
      this.dialogVisible = true;
    },
    adjustingRecords(row) {
      this.isShowAdjustmentRecord = true
      this.rowData = row
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
